import styled, { keyframes, css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

const scaleIn = keyframes`
    0% {
      transform: scaleX(0);
    }
    100% {
      transform: scaleX(1);
    }
`;

export const TabItem = styled.button<{ selected: boolean }>`
  position: relative;
  text-decoration: none;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.darkBlue};
  margin-right: 2rem;
  margin-bottom: 1rem;
  white-space: nowrap;
  border: 0;
  outline: 0;
  background-color: transparent;
  cursor: pointer;

  &:after {
    height: 3px;
    background-color: ${({ theme }) => theme.colors.lightBlue};
    position: absolute;
    content: '';
    width: calc(100% - 0.25rem);
    bottom: -8px;
    left: 0.125rem;

    transform: scaleX(0);
    ${({ selected }) =>
      selected &&
      css`
        animation: ${scaleIn} 0.2s forwards;
      `}
  }
`;
